// Cinematic infrastructure photography. Drone and architectural shots.
// Sourced from Unsplash. Industrial, energy, healthcare, agribusiness focus.
export const IMAGERY = {
  heroPort:
    "https://images.unsplash.com/photo-1494412519320-aa613dfb7738?auto=format&fit=crop&w=2400&q=80",
  // Container terminal / port aerial
  port:
    "https://images.unsplash.com/photo-1577416412292-747c6607f055?auto=format&fit=crop&w=1800&q=80",
  // Power transmission lines twilight
  grid:
    "https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?auto=format&fit=crop&w=1800&q=80",
  // Solar array drone
  solar:
    "https://images.unsplash.com/photo-1509391366360-2e959784a276?auto=format&fit=crop&w=1800&q=80",
  // Modern hospital architecture
  hospital:
    "https://images.unsplash.com/photo-1538108149393-fbbd81895907?auto=format&fit=crop&w=1800&q=80",
  // Aerial agriculture
  agri:
    "https://images.unsplash.com/photo-1500382017468-9049fed747ef?auto=format&fit=crop&w=1800&q=80",
  // Skyline / corporate
  skyline:
    "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=1800&q=80",
  // Industrial cranes night
  cranes:
    "https://images.unsplash.com/photo-1565017228812-d35d8c5c6d54?auto=format&fit=crop&w=1800&q=80",
  // Architectural detail / steel
  steel:
    "https://images.unsplash.com/photo-1486325212027-8081e485255e?auto=format&fit=crop&w=1800&q=80",
  // Boardroom / executive
  executive:
    "https://images.unsplash.com/photo-1606857521015-7f9fcf423740?auto=format&fit=crop&w=1800&q=80",
  // Wind turbines
  wind:
    "https://images.unsplash.com/photo-1466611653911-95081537e5b7?auto=format&fit=crop&w=1800&q=80",

  // Sean Pollock skyscrapers from below: iconic architectural shot
  // used by the Leadership section ("Strategic Intelligence" feel).
  leadershipSkyscraper:
    "https://images.unsplash.com/photo-1517502884422-41eaead166d4?auto=format&fit=crop&w=2400&q=85",

  // ===== HOME: "Excellence in Detail" sidebar image =====
  // Vast aerial of São Paulo, Latin America's largest financial center.
  // Dark CSS filter applied at usage to render as institutional dusk/night.
  excellenceSP:
    "https://images.pexels.com/photos/97906/pexels-photo-97906.jpeg?auto=compress&cs=tinysrgb&w=2400",

  // ===== HERO CAROUSEL (Home page, 3-slide rotator) =====
  // Slide 1: panoramic 16:9 crop of Rio at night (Sugarloaf + Botafogo Bay).
  // Generated from the original 3750x5000 photo, downsized to 1920x1080,
  // mild brightness/contrast/sharpness enhancement, web-optimized.
  rioCity: "/rio-panorama.jpg",
  // Slide 2: cinematic empty surgical theatre. High-contrast healthcare.
  healthcareTheatre:
    "https://images.pexels.com/photos/247786/pexels-photo-247786.jpeg?auto=compress&cs=tinysrgb&w=2400",
  // Slide 3: iconic oil pumpjack silhouette at sunset. Energy/Oil & Gas.
  energyPump:
    "https://images.pexels.com/photos/162568/oil-pump-jack-sunset-clouds-silhouette-162568.jpeg?auto=compress&cs=tinysrgb&w=2400",
  // Slide 4: AI-generated São Paulo financial district aerial at dusk.
  spFinancialDusk: "/slide-sp-financial.jpg",
  // Slide 5: AI-generated FPSO + Brazilian cerrado resource-depth composite.
  resourcesFusion: "/slide-resources-fusion.jpg",
  // Slide 6: AI-generated offshore wind turbines with transmission grid blueprint.
  energyFuture: "/slide-energy-future.jpg",

  // ===== Cinematic 4K specifics for Capabilities page =====
  // Strategic M&A Advisory: drone-perspective Manhattan financial corridor at
  // sunset. Photorealistic, evokes transaction lifecycle and cross-border scale.
  mnaAdvisory:
    "https://images.unsplash.com/photo-1480714378408-67cf0d13bc1b?auto=format&fit=crop&w=2400&q=90",
  // Financial Architecture & Valuation: illuminated skyline architecture at
  // night. Reads as structured capital, audit-grade modeling, financial scaffolding.
  valuationData:
    "https://images.unsplash.com/photo-1486325212027-8081e485255e?auto=format&fit=crop&w=2400&q=90",

  // ===== SECTORS PAGE: 6 cinematic photorealistic sector hero shots =====
  sectorsHero: "/sectors-hero.png",
  solutionsHero: "/solutions-hero.png",
  sectorHealthcare:
    "https://images.pexels.com/photos/247786/pexels-photo-247786.jpeg?auto=compress&cs=tinysrgb&w=2400",
  sectorAgribusiness:
    "https://images.pexels.com/photos/422218/pexels-photo-422218.jpeg?auto=compress&cs=tinysrgb&w=2400",
  sectorOilGas:
    "https://images.pexels.com/photos/162568/oil-pump-jack-sunset-clouds-silhouette-162568.jpeg?auto=compress&cs=tinysrgb&w=2400",
  sectorMining:
    "https://images.pexels.com/photos/2101137/pexels-photo-2101137.jpeg?auto=compress&cs=tinysrgb&w=2400",
  sectorCleanEnergy:
    "https://images.pexels.com/photos/414837/pexels-photo-414837.jpeg?auto=compress&cs=tinysrgb&w=2400",
  sectorCommodities:
    "https://images.pexels.com/photos/916406/pexels-photo-916406.jpeg?auto=compress&cs=tinysrgb&w=2400",
};
